<template>
    <div class="step2-container">
        <div class="main-content-container no-scrollbar">
            <div class="storefront-header" :class="[(selectedAddonProducts.length > 0) ? 'big' : '']" :style="storefrontHeaderConfig ? 'background-color:' + storefrontHeaderConfig.color : ''" v-if="currentOccassionImage">
                <div class="custom-header" v-if="showCustomHeader">
                    <img :src="storefrontHeaderConfig.image"/>
                    <p :style="storefrontHeaderConfig && storefrontHeaderConfig.textColor  ? 'color:' + storefrontHeaderConfig.textColor : ''">{{ storefrontHeaderConfig.text != "" ? storefrontHeaderConfig.text : "Welcome to Your Custom Box Builder" }}</p>
                </div>
            </div>
            <div class="content-header" :class="[(selectedAddonProducts.length > 0) ? 'cart' : '']">
                <div v-if="steps && steps.length > 0" class="title" v-html="steps[0].html"></div>
                <p v-else class="title">Step 1: Start by picking gifts to add to your box</p>
            </div>
            <div id="header-container" class="header-container" :class="[isSticking ? 'sticky' : '',(selectedAddonProducts.length > 0) ? 'cart' : '']">
                <div v-if="currentOccassionImage" class="placeholder-recommendations">
                    <div class="buttons-container">
                        <button v-if="hasHBProducts" class="happybox-button white border" :class=" totalCurrentFilters > 0 ? 'selected' : ''" @click="showFilters()">
                            <img v-if="totalCurrentFilters > 0" class="purple" src="https://cdn.shopify.com/s/files/1/1363/8433/files/filter_purple.svg?v=1723141690"/>
                            <img v-else class="normal" src="https://cdn.shopify.com/s/files/1/1363/8433/files/filters.png?v=1722266559"/>
                            Filters 
                            <span v-if="totalCurrentFilters > 0">({{ totalCurrentFilters }})</span>
                        </button>
                        <button v-if="hasHBProducts" class="happybox-button white border" @click="showSort()"><img src="https://cdn.shopify.com/s/files/1/1363/8433/files/Group_4412.png?v=1722267051"/>Sort</button>
                    </div>
                    <div class="sticky-image-container">
                        <p class="steps">
                            STEP 1 OF 3: <span class="legend">Start adding gifts!</span>
                            <span class="dot current">
                                <span class="selected"></span>
                            </span>
                            <span class="dot">
                                <span></span>
                            </span>
                            <span class="dot">
                                <span></span>
                            </span>
                        </p>
                    </div>
                    <p  class="leave-builder" @click="leaveBuilder">
                        <span v-tooltip="'Save your selections for 24 hours. Inventory subject to availability'">
                            SAVE
                        </span>
                        <img v-tooltip="'Save your selections for 24 hours. Inventory subject to availability'" src="https://cdn.shopify.com/s/files/1/1363/8433/files/save_cart.svg?v=1722005665" alt="save cart">
                    </p>
                </div>
            </div>
            <div class="content-container no-scrollbar">
                <div class="products-wrapper" :class="[(selectedAddonProducts.length > 0) ? 'big' : '']">
                    <ul v-if="!addonProducts || addonProducts.length == 0" class="products-container no-scrollbar">
                        <li v-for="n in 12" :key="n">
                            <AddonProductSkeleton v-for="n in 12" :key="n" />
                        </li>
                    </ul>
                    <ul v-else class="products-container no-scrollbar">
                        <p class="other-gifts" :style="giftConfiguration && giftConfiguration.corporateStyle ? giftConfiguration.corporateStyle : ''">{{giftConfiguration && giftConfiguration.corporateText ? giftConfiguration.corporateText : corpName + ' Custom Gifts'}}</p>
                        <li v-for="addonProduct in corpProducts" :key="'corp_' + addonProduct.id">
                            <AddonProductNew 
                            @loadmodal="openModal($event)" 
                            :product="addonProduct" 
                            :cartProducts="selectedAddonProducts"
                            :maxCapacity="maxCapacity"
                            :currentCapacity="currentCapacity"
                            :boxQty="boxQty"
                            :productLimit="productLimit"
                            :addCopy="addCopy"
                            />
                        </li>
                        <p class="other-gifts" :style="giftConfiguration && giftConfiguration.allStyle ? giftConfiguration.allStyle : ''" v-if="sortedProducts.length > 0">{{breadcrumbText}}</p>
                        <li v-for="addonProduct in sortedProducts" :key="'sorted_' + addonProduct.id">
                            <AddonProductNew 
                            @loadmodal="openModal($event)" 
                            :product="addonProduct" 
                            :cartProducts="selectedAddonProducts"
                            :maxCapacity="maxCapacity"
                            :currentCapacity="currentCapacity"
                            :boxQty="boxQty"
                            :productLimit="productLimit"
                            :addCopy="addCopy"
                            />
                        </li>
                        <p class="other-gifts" v-if="nonFilteredProducts.length > 0">All Other Gifts</p>
                        <li v-for="addonProduct in nonFilteredProducts" :key="'nonfiltered_' + addonProduct.id">
                            <AddonProductNew 
                            @loadmodal="openModal($event)" 
                            :product="addonProduct" 
                            :cartProducts="selectedAddonProducts"
                            :maxCapacity="maxCapacity"
                            :currentCapacity="currentCapacity"
                            :boxQty="boxQty"
                            :productLimit="productLimit"
                            :addCopy="addCopy"
                            />
                        </li>
                    </ul>
                </div>
                <SideCartNew 
                    v-show="isSticking" 
                    :isSticking="isSticking" 
                    :step="1"
                    @changepage="changePage($event)" 
                    @openmodal="openModal($event)"
                    @gostep="goStep($event)"
                />
            </div>
        </div>
        <SideCartNew 
            v-show="!isSticking" 
            :isSticking="isSticking" 
            @changepage="changePage($event)" 
            @openmodal="openModal($event)"
            @gostep="goStep($event)"
            :step="1" 
        />
        <AddonProductModal 
            v-if="showModal == true && currentSelectedAddon != null" 
            :selectedAddon="currentSelectedAddon"
            :addonProducts="modalProducts"
            :cartProducts="selectedAddonProducts"
            :recommendedProducts="modalRecommendedProducts"
            @closemodal="closeModal()"
            @changeselectedaddon="openModal($event)"
        >
        </AddonProductModal>
        <FiltersMobile :filteredPreAddons="filteredPreProducts" @closefilter="showFilters()" v-if="filterIsShown" :filteredAddons="sortedProducts"/>
        <SortMobile @closefilter="showSort()" v-if="sortIsShown"/>
    </div>
</template>
    
<script>
import AddonProductNew from './AddonProductNew.vue';
import SideCartNew from './SideCartNew.vue'
import AddonProductModal from './AddonProductModal.vue'
import Filters from './Filters.vue'
import { mapGetters } from 'vuex';
import confetti from "canvas-confetti";
import AddonProductSkeleton from "./Skeletons/AddonProductSkeleton.vue"
import FiltersMobile from './Step2Mobile/FiltersMobile.vue'
import SortMobile from './Step2Mobile/SortMobile.vue'

export default {
    components: {
        AddonProductNew,
        SideCartNew,
        AddonProductModal,
        Filters,
        AddonProductSkeleton,
        FiltersMobile,
        SortMobile
    },
    data() {
        return{
            selectedAddon: null,
            showModal: false,
            isAllItems: false,
            isSticking: false,
            isChanging: false,
            selectedSecondOccasion: null,
            filterIsShown: false,
            sortIsShown: false,
        }
    },
    watch:{
        selectedCategories:{ 
            handler(newVal){
                this.scrollHeader();
            },
            deep: true
        },
        selectedFilters:{ 
            handler(newVal){
                this.scrollHeader();
            },
            deep: true
        },
        selectedOccasion:{ 
            handler(newVal){
                this.scrollHeader();
            },
            deep: true
        },
        cartLength:{
            handler(val,oldVal){
                if(val > oldVal && oldVal < 5){
                    confetti({origin:{
                        x: this.x
                        ,y: this.y
                    }});
                }
            }
        }
    },
    computed: {
        ...mapGetters([
            'addonProducts',
            'selectedAddonProducts',
            'boxQty',
            'maxCapacity',
            'currentCapacity',
            'selectedSort',
            'rangePrice',
            'selectedCategories',
            'selectedFilters',
            'productLimit',
            'addCopy',
            'categories',
            'budget',
            'currentBudget',
            'storefrontHeaderConfig',
            'corpName',
            'steps',
            'hasHBProducts',
            'giftConfiguration'
        ]),
        selectedOccasion: {
            get(){ return this.$store.state.selectedOccasion},
            set(value){
                this.$store.commit('setSelectedOccasion', value );
            }
        },
        totalCurrentFilters(){
            let total = this.selectedOccasion.length + this.selectedCategories.filter(x => x != 'View All').length + this.selectedFilters.length;
            return total
        },
        breadcrumbText(){
            if(this.giftConfiguration && this.giftConfiguration.allText){
                return this.giftConfiguration.allText
            }
            if(this.showReco)
                return `All products`
            let text = "";
            if(this.selectedOccasion.length > 0)
                text += this.selectedOccasion.join(", ");
            else 
                text += "All products";

            if(!this.selectedCategories.includes("View All"))
                text += ` > ${this.selectedCategories.join(", ")}`
            return text;
        },
        cartLength(){
            return this.selectedAddonProducts.length;
        },
        showReco(){
            return this.selectedOccasion.length == 0 && this.selectedFilters.length == 0 && this.selectedCategories.includes("View All");
        },
        notFilter(){
            return this.selectedOccasion.length == 0 && this.selectedFilters.length == 0
        },
        occasionProducts(){
            let products = [];
            if(this.categories && this.categories.filters && this.categories.filters.length > 0){
                for(let [i, occasion] of this.categories.filters.entries()){
                    let current = this.addonProducts.filter(x => x.tags.some(y => y.includes(occasion.title)));
                    if(current.length > 0){
                        switch(this.selectedSort){
                            case "2":
                                current.sort((a,b) => {
                                    var aIsIncluded = a.tags.some(x => x.includes("Filter_Badges_Best Sellers"));
                                    var bIsIncluded = b.tags.some(x => x.includes("Filter_Badges_Best Sellers"));
                                    if(aIsIncluded == bIsIncluded){
                                        return 0;
                                    }
                                    else if(aIsIncluded == true){
                                        return -1;
                                    }
                                    else if(bIsIncluded == true){
                                        return 1;
                                    }
                                });
                                break
                            case "3":
                                current.sort((a,b) => {
                                    var aIsIncluded = this.dateDiffInDays(new Date(a.published_at),new Date()) < 60;
                                    var bIsIncluded = this.dateDiffInDays(new Date(b.published_at),new Date()) < 60;
                                    if(aIsIncluded == bIsIncluded){
                                        return 0;
                                    }
                                    else if(aIsIncluded == true){
                                        return -1;
                                    }
                                    else if(bIsIncluded == true){
                                        return 1;
                                    }
                                })
                                break
                            case "4":
                                current.sort((a,b) => { return a.variants[0].price - b.variants[0].price});
                                break;
                            case "5":
                                current.sort((a,b) => { return b.variants[0].price - a.variants[0].price})
                                break;
                            default:
                                break;
                        }
                        if(i == 0){
                            current.splice(7, 0, "ad");
                        }
                        products.push({occasion: occasion.title,products: current});
                    }
                }
            }

            products.sort((a,b) => {
                let iA = a.occasion.includes("Brandable Swag") ? 1 : 0;
                let iB = b.occasion.includes("Brandable Swag") ? 1 : 0;

                return iA - iB;
            })

            if(!this.selectedCategories.includes("View All")){
                products.sort((a,b) => {
                    let iA = this.selectedCategories.includes(a.occasion) ? 1 : 0;
                    let iB = this.selectedCategories.includes(b.occasion) ? 1 : 0;

                    return iB - iA;
                })
            }

            return products
        },
        corpProducts(){
            return this.addonProducts.filter(x => x.tags.some(y => y.includes(this.corpName)));
        },
        filteredPreProducts(){
            let filterAddons =  JSON.parse(JSON.stringify(this.addonProducts));
            //remove corp products
            filterAddons = filterAddons.filter(x => x.tags.every(y => !y.includes(this.corpName)));

            //filter via occasion
            if(this.selectedOccasion.length > 0){
                filterAddons = filterAddons.filter(x => x.tags.some(y => this.selectedOccasion.some(z => y.includes(z))));
            }

            //Filter categories
            if(!this.selectedCategories.includes("View All"))
                filterAddons = filterAddons.filter(x => x.tags.some(y =>  this.selectedCategories.some(z => y.includes(z))));

            //Filter for each category
            for(let filter of this.selectedFilters){
                filterAddons = filterAddons.filter(x => filter.filters.some(y => x.tags.includes(y)));
            }

            //Exclude products
            let excludeFilters = this.selectedAddonProducts.filter(x => x.tags.some(y => y.includes("Exclude_")));
            if(excludeFilters.length > 0){
                let excludedTags = excludeFilters.flatMap(x => x.tags.filter(y => y.includes("Exclude_")));
                excludedTags = excludedTags.map(x => parseInt(x.replaceAll("Exclude_","")));
                filterAddons = filterAddons.filter(x => !excludedTags.includes(x.id));
            }
            
            return filterAddons;
        },
        filteredProducts(){
            //Filter Price
            return this.filteredPreProducts.filter(x => ((x.variants[0].price-this.rangePrice.min)*(x.variants[0].price-this.rangePrice.max) <= 0));
        },
        nonFilteredProducts(){
            let ids = this.filteredProducts.map(x => x.id);
            let excludeFilters = this.selectedAddonProducts.filter(x => x.tags.some(y => y.includes("Exclude_")));
            if(excludeFilters.length > 0){
                let excludedTags = excludeFilters.flatMap(x => x.tags.filter(y => y.includes("Exclude_")));
                excludedTags = excludedTags.map(x => parseInt(x.replaceAll("Exclude_","")));
                return this.addonProducts.filter(x => !ids.includes(x.id) && !excludedTags.includes(x.id));
            }
            return this.addonProducts.filter(x => !ids.includes(x.id) && x.tags.every(y => !y.includes(this.corpName)));
        },
        sortedProducts(){
            var sortedProducts = JSON.parse(JSON.stringify(this.filteredProducts));
            switch(this.selectedSort){
                case "2":
                    sortedProducts.sort((a,b) => {
                        var aIsIncluded = a.tags.some(x => x.includes("Filter_Badges_Best Sellers"));
                        var bIsIncluded = b.tags.some(x => x.includes("Filter_Badges_Best Sellers"));
                        if(aIsIncluded == bIsIncluded){
                            return 0;
                        }
                        else if(aIsIncluded == true){
                            return -1;
                        }
                        else if(bIsIncluded == true){
                            return 1;
                        }
                    });
                    break
                case "3":
                    sortedProducts.sort((a,b) => {
                        var aIsIncluded = this.dateDiffInDays(new Date(a.published_at),new Date()) < 60;
                        var bIsIncluded = this.dateDiffInDays(new Date(b.published_at),new Date()) < 60;
                        if(aIsIncluded == bIsIncluded){
                            return 0;
                        }
                        else if(aIsIncluded == true){
                            return -1;
                        }
                        else if(bIsIncluded == true){
                            return 1;
                        }
                    })
                    break
                case "4":
                    sortedProducts.sort((a,b) => { return a.variants[0].price - b.variants[0].price});
                    break;
                case "5":
                    sortedProducts.sort((a,b) => { return b.variants[0].price - a.variants[0].price})
                    break;
                default:
                    break;
            }

            //Filter onDemand Product
            sortedProducts = sortedProducts.filter((x) => {
                let inCart = this.selectedAddonProducts.find(y => y.id == x.id );
                if(inCart)
                    return true;
                let indexVariant =  x.variants.findIndex(x =>x.sku && x.sku.toLowerCase().includes("ondemand"));
                if(indexVariant > -1){
                    if(this.boxQty >= this.demandQtyMin(x)){
                        return true
                    }
                    else {
                        let indexNotDemand =  x.variants.findIndex(x => !x.sku.toLowerCase().includes("ondemand"));
                        return x.variants[indexNotDemand].inventory_quantity >= this.boxQty
                    }
                }

                return x.variants.some(y => y.inventory_quantity >= this.boxQty);
            })

            return sortedProducts;
        },
        currentSelectedAddon(){
            if(this.selectedAddon){
                return this.selectedAddon;
            }
            else if(this.addonProducts.length > 0){
                return this.addonProducts[0];
            }
            else
                return null
        },
        recoProducts(){
            let products = this.addonProducts.filter(x => x.tags.some(y => y.toLowerCase() == "builder_reco"))

            return products
        },
        isOtherOccasion(){
            return this.selectedOccasion.includes("View All");
        },
        currentOccassionImage(){
            return "https://cdn.shopify.com/s/files/1/1363/8433/files/unexpected.svg?v=1683559909";
        },
        modalProducts(){
            var addonCartIds = this.selectedAddonProducts.map(x => x.id)
            return this.sortedProducts.filter(x => 
                ((this.maxCapacity > (this.currentCapacity + x.capacity)) 
                && (this.boxQty < x.variants[0].inventory_quantity)
                && (parseInt(x.variants[0].price) + this.currentBudget) <= this.budget
                )
                || addonCartIds.includes(x.id)
            )
        },
        modalRecommendedProducts(){
            var addonCartIds = this.selectedAddonProducts.map(x => x.id);
            if(this.filteredPreProducts.length > 0){
                let products = this.filteredPreProducts.filter(x => !addonCartIds.includes(x.id) && x.tags.every(y => !y.includes("Brandable Swag") && !y.toLowerCase().includes("Pairs_exclude")) && ((parseInt(x.variants[0].price) + this.currentBudget) <= this.budget));
                return products.sort((a,b) => a.capacity - b.capacity);
            }
            else{
                return this.addonProducts.filter(x => !addonCartIds.includes(x.id) && x.tags.every(y => !y.includes("Brandable Swag") && !y.toLowerCase().includes("Pairs_exclude")) && ((parseInt(x.variants[0].price) + this.currentBudget) <= this.budget)).sort((a,b) => a.capacity - b.capacity );
            }
        },
        showCustomHeader(){
            return this.storefrontHeaderConfig && this.storefrontHeaderConfig.color && this.storefrontHeaderConfig.image;
        }
    },
    methods: {
        showFilters(){
            this.filterIsShown = !this.filterIsShown;
        },
        showSort(){
            this.sortIsShown = !this.sortIsShown;
        },
        openModal(product){
            ga('send', {
                hitType: 'event',
                eventCategory: 'Build A Box',
                eventAction: 'Open Product',
                eventLabel: product.title
            });
            this.selectedAddon = product;
            this.showModal = true;
        },
        closeModal(){
            this.showModal = false;
        },
        changePage(increment){
            const header = document.querySelector('.site-header');
            if (header) header.style.display = 'block';
            this.$emit("changepage", increment);
        },
        dateDiffInDays(a, b) {
            const _MS_PER_DAY = 1000 * 60 * 60 * 24;
            // Discard the time and time-zone information.
            const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
            const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
            return Math.floor((utc2 - utc1) / _MS_PER_DAY);
        },
        demandQtyMin(addon){
            let demandQtymin = addon.tags.find(x => x.includes("DEMAND_QTYMIN"));
            if(demandQtymin){
                if(demandQtymin){
                    demandQtymin = demandQtymin.split("_");
                    demandQtymin = demandQtymin[demandQtymin.length - 1];

                    return  parseInt(demandQtymin);
                }
            }

            return 0;
        },
        leaveBuilder(){
            const header = document.querySelector('.site-header');
            if (header) header.style.display = 'block';
            this.$emit("leavebuilder");
        },
        onMouseMove(e){
          this.x = e.clientX / window.innerWidth;
          this.y = e.clientY / window.innerHeight;
        },
        scrollHeader(){
            document.getElementById('PageContainer')?.scrollTo({ top: 0, behavior: 'auto' });
        },
        goStep(step){
            this.$emit("gostep",step);
        }
    },
    mounted(){
        window.addEventListener('mousemove', this.onMouseMove, false);
        var that = this;
        var element = document.getElementById("header-container");
        var root = document.querySelector(".build-wrapper");
        var observer = new IntersectionObserver(function(entries) {
            if(entries[0].intersectionRatio < 1){
                setTimeout(function(){
                    that.isSticking = true;
                }, 200);
            }
            else{
                setTimeout(function(){
                    that.isSticking = false;
                }, 200);
            }
        }, { threshold: [0,1],root: root });

        observer.observe(element);
    },
}
</script>
<style>
#PageContainer{
	height: calc(100vh - 90px);
    overflow-y: scroll;
    font-size: 0;
    min-height: calc(100vh - 90px);
}

.main-content,.BuildABox{
	display: inline !important;
	font-size: 0;
}

.step2-container .content-header .title > p{
    font-size: 2vw;
    line-height: .8;
    font-weight: bold;
    margin: unset;
    margin-bottom: 1rem;
}
</style>
<style scoped>

.header-container{
    position: sticky;
    top: -1px;
    left: 0px;
    background-color: white;
    z-index: 4;
    width: 100%;
    padding: 1px 10% 0;
}

.header-container.cart{
    padding: 0 10px 0 10vw;
}

.header-container.sticky.cart{
    padding: 0 10vw;
}
.header-container.sticky{
    box-shadow: -2px 0px 1px 2px rgba(0,0,0,0.2);
}

.step2-container{
    width: 100%;
    display: flex;
}

.main-content-container{
    min-width: 90%;
    width: 100%;
    max-width: 100%;
    display: flex;
    flex-direction: column;
}

.main-content-container .content-container{
    width: 100%;
    display: flex;
    flex-direction: row;
    position: relative;
    justify-content: flex-start;
    padding-top: 1%;
}

 .separator{
    width: 96%;
    border-bottom: 1px solid #E5E7EB;
    margin: 2% 0% 0% 2%;
}

.placeholder-recommendations{
    width: 100%;
    display: flex;
    justify-content: flex-start;
    background-color: white;
    align-items: center;
    min-height: 45px;
}

.placeholder-recommendations img{
    width: 100%;
    padding: 1% 10%;
}

.leave-builder,.breadcrumb{
    font-size: 1vw;
    line-height: 1.5;
    letter-spacing: .08em;
    text-transform: uppercase;
    font-weight: 700;
    text-align: center;
    display: flex;
    align-items: center;
    flex: 1;
    z-index: 1;
    cursor: pointer;
}

.header-container .buttons-container{
    display: flex;
    gap: 5%;
    flex: 1;
}

.header-container .buttons-container button{
    display: flex;
    gap: 5px;
    align-items: center;
    padding: 1% 5%;
}

.header-container .buttons-container button.selected{
    color: #a01adb;
    font-weight: 700;
    border: 1px solid #a01adb;
}

.header-container .buttons-container button.selected span{
    color: #a01adb;
    font-weight: 700;
}

.header-container .buttons-container button img{
    width: 15px;
    padding: unset
}

.leave-builder{
    justify-content: flex-end;
    gap: 5px;
}

.leave-builder span{
    line-height: 0;
}

.leave-builder img{
    width: 15px;
    padding: unset;
}

.sticky-image-container{
    flex: 3;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.sticky .sticky-image-container .steps{
    display: flex;
}

.sticky-image-container .steps{
    width: 100%;
    font-size: 1vw;
    letter-spacing: .08em;
    line-height: 1.5;
    font-weight: 700;
    text-align: center;
    display: none;
    align-items: center;
    justify-content: center;
}

.sticky-image-container .steps .legend{
    margin: 0 0.5rem;
    letter-spacing: 0;
}

.sticky-image-container .steps .dot{
    display: flex;
    align-items: center;
    padding: 0.5%;
    border-radius: 50%;
    margin: 0% 0.5%;
}

.sticky-image-container .steps .dot.current{
    background-color: #f5eefe;
}

.sticky-image-container .steps .dot span{
    height: 0.65vw;
    width: 0.65vw;
    background-color: black;
    border-radius: 50%;
    display: inline-block;
    opacity: 0.5;
}

.sticky-image-container .steps .dot span.selected{
    opacity: 1;
}

.categories-container{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.categories-container div{
    display: flex;
}

.categories-container button{
    margin: 0% 1%;
    font-family: 'Karla';
    font-style: normal;
    font-weight: 400;
    font-size: 1.2vw;
    line-height: 1.3;
    color: #0F0C38;
}

.categories-container button.selected{
    font-weight: bold;
    border-bottom: 1px solid #0F0C38;
    padding-bottom: 1%;
}

.products-wrapper{
    width: 100%;
    padding: 0 10% 0 10%;
}

.products-wrapper.big{
    width: 100%;
    padding: 0 0 0 10vw;
}

.products-wrapper .mini-header{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 1rem;
}

.mini-header .product-sort, .mini-header .sticky-image-container{
    flex: 1;
}

.products-container{
    width: 100%;
    height: fit-content;
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    overflow-y: scroll;
    margin: 0;
    gap: 2.66%;
}

.products-container li{
    width: 23%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.recommended-product-container{
    width: 85%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    justify-content: space-between;
    overflow-y: scroll;
    padding-top: 2%;
    padding-left: 2%;
}

.category-products-container{
    width: 100%;
}

.category-products-container .category-title{
    padding-left: 2.5%;
    font-family: 'Moret';
    font-size: 1.8vw;
    line-height: 1.23;
    letter-spacing: 0.03em;
    color: #0F0C38;
    padding-bottom: 2%;
}

.category-products-container .products-container{
    width: 100%;
    padding: 0% 2.5%;
    margin: 0;
}

.view-all-products-container{
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    text-align: center;
    cursor: pointer;
    position: relative;
}

.view-all-products-container .main-image{
    width: 100%;
}

.view-all-products-container .small-arrow{
    width: 10%;
    position: absolute;
    bottom: 5%;
}

.sort-container{
    width: 100%;
    display: flex;
    justify-content: space-between;
    background-color: white;
}

.product-sort{
    display: flex;
    width: 25%;
    align-items: center;
    justify-content: center;
    gap: 5%;
}

.product-sort span{
    font-weight: bold;
    font-size: 1.1vw;
    line-height: 1.3;
    color: #0F0C38;
}

.product-sort select{
    width: auto;
    padding: 2% 15% 2% 2%;
    border: 1px solid #F3EEFA;
    box-shadow: 0px 1px 2px rgba(31, 41, 55, 0.08);
    border-radius: 100px;
    font-size: 0.8vw;
    line-height: 1.3;
    color: #0F0C38;
    height: unset;
}

.other-gifts{
    width: 100%;
    font-family: Karla,sans-serif;
    text-transform: capitalize;
    font-weight: bold;
    font-size: 1.3vw;
    margin: 1rem 0;
}

.other-gifts span{
    font-family: ff-more-web-pro-condensed, Karla, sans-serif;
}

.custom-separator{
    width: 100%;
    font-family: Karla, sans-serif;
    text-transform: capitalize;
    font-weight: 700;
    font-size: 2vw;
    text-align: center;
    margin-top: 4rem;
}

.cartNumber {
    top: -40%;
    right: -2%;
    position: absolute;
    background-color: #FFE245;
    border-radius: 50%;
    height: 16px;
    width: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.cartNumber span {
    color: #0B3245;
    font-weight: bold;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    font-size: 12px;
}

.video-container{
    width: 100%;
    display: flex;
    position: relative;
}

.title-container{
    width: 50%;
    position: absolute;
    top: 0%;
    right: 10%;
    text-align: center;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.title-container .title{
    font-size: 4.5vw;
    line-height: 0.8;
    font-family: Founders Grotesk, sans-serif;
    font-weight: 600;
    margin: unset;
    margin-bottom: 1rem;
}

.title-container .instructions{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.title-container .instructions div{
    width: 26%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.title-container .instructions div img{
    margin-bottom: 0.5rem;
    height: 5vw;
}

.title-container .instructions .first img{
    max-width: 50%;
}

.title-container .instructions .last img{
    padding: 2%;
}

.title-container .instructions div{
    font-size: 1.2vw;
    line-height: 1.2;
    font-weight: bold;
}

.content-header{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2% 10% 0;
}

.content-header.cart{
    padding: 2% 0 0 10vw;
}

.content-header .title{
    font-size: 2vw;
    line-height: .8;
    font-weight: bold;
    margin: unset;
    margin-bottom: 1rem;
}

.storefront-header{
    display: flex;
    width: 100%;
    justify-content: center;
    height: 10vh;
}

.custom-header img{
    height: 50%;
    width: auto;
}

.custom-header{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 55%;
    gap: 5%;
}

.big .custom-header{
    width: 65%;
}

.custom-header p{
    color: white;
    font-family: Founders Grotesk, sans-serif;
    font-size: 3vw;
}
</style>